import { supabase } from "@/integrations/supabase/client";

export type EntityType = "product" | "customer" | "vendor";
export type ActionType = "deleted" | "created" | "updated";

interface LogActivityParams {
  organizationId: string;
  entityType: EntityType;
  entityId: string;
  entityName: string;
  actionType: ActionType;
  details?: Record<string, unknown>;
}

export async function logActivity({
  organizationId,
  entityType,
  entityId,
  entityName,
  actionType,
  details = {},
}: LogActivityParams): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    // Use type assertion since the table was just created and types may not be updated yet
    const { error } = await (supabase as any)
      .from("activity_log")
      .insert({
        organization_id: organizationId,
        entity_type: entityType,
        entity_id: entityId,
        entity_name: entityName,
        action_type: actionType,
        performed_by: user?.id || null,
        details,
      });

    if (error) {
      console.error("Failed to log activity:", error);
    }
  } catch (error) {
    console.error("Error logging activity:", error);
  }
}

export async function logDeletion(
  organizationId: string,
  entityType: EntityType,
  entityId: string,
  entityName: string,
  additionalDetails?: Record<string, unknown>
): Promise<void> {
  return logActivity({
    organizationId,
    entityType,
    entityId,
    entityName,
    actionType: "deleted",
    details: {
      deletedAt: new Date().toISOString(),
      ...additionalDetails,
    },
  });
}

export async function logCreation(
  organizationId: string,
  entityType: EntityType,
  entityId: string,
  entityName: string,
  additionalDetails?: Record<string, unknown>
): Promise<void> {
  return logActivity({
    organizationId,
    entityType,
    entityId,
    entityName,
    actionType: "created",
    details: {
      createdAt: new Date().toISOString(),
      ...additionalDetails,
    },
  });
}
